export default __webpack_public_path__ + "static/media/Deacon's Leggings of the Earthen Prison.e3326f74.jpg";